module.exports = __webpack_public_path__ + "static/media/logo-inverse.87e64f6e.png";